type InboxNavWorkspace = {
    isStarter?: boolean
    inboxEnabled?: boolean
} | null | undefined

/** Starter without admin inbox flag — nav item disabled with upgrade tooltip. */
export const isInboxNavDisabledForStarter = (workspace: InboxNavWorkspace) =>
    !!workspace?.isStarter && !workspace?.inboxEnabled

/**
 * Whether Inbox nav should open the in-app inbox (/inbox).
 * Pro/Business: always. Starter/Lifetime: only when inboxEnabled.
 */
export const shouldOpenNewInbox = (workspace: InboxNavWorkspace, lifetime: boolean) => {
    if (workspace?.isStarter) return !!workspace.inboxEnabled
    if (lifetime) return !!workspace?.inboxEnabled
    return true
}
